/**
 * @owner @Appboy/whats-app
 * Common schema to share between template message GET and POST shapes
 */

import { z } from "zod";
import { common } from "../common";
import { whatsAppCommerceDataSchema } from "./whatsAppCommerceDataSchema";
import { whatsAppCarouselCardSchema } from "./whatsAppCarouselCardSchema";
import { whatsAppMediaHeaderSchema } from "@schemas/message/whatsAppMediaTypeSchema";

// Refer to whatsapp-message.ko.ts fromAjaxData (accepts GET shape)
// Refer to whatsapp-template-message.ko.ts getObjectForExport (returns POST shape)
export const whatsAppTemplateMessageCommonSchema = z.object({
  message_type: z.literal("whatsApp"),
  whats_app_message_type: z.literal("template"),

  // undefined: 12_736 (41.77%), defined 17_752 (58.23%)
  // null: 1_387 (7.81%)
  template_name: z.string().nullable().optional(),
  // undefined: 12_736 (41.77%), defined 17_752 (58.23%)
  // null: 1_345 (7.58%)
  language: z.string().nullable().optional(),
  template_id: common.objectId.nullable().optional(),

  // undefined: 12_736 (41.77%), defined 17_752 (58.23%)
  // null: 193 (1.09%)
  header_liquid_variables: z.array(z.string()).nullable().optional(),
  // undefined: 12_736 (41.77%), defined 17_752 (58.23%)
  // null: 193 (1.09%)
  body_liquid_variables: z
    .array(
      // null: 90 (0.63%)
      z.string().nullable()
    )
    .nullable()
    .optional(),
  // undefined: 12_736 (41.77%), defined 17_752 (58.23%)
  // null: 193 (1.09%)
  button_liquid_variables: z
    .array(
      // null: 18_129 (89.41%)
      z.string().nullable()
    )
    .nullable()
    .optional(),

  ...whatsAppMediaHeaderSchema.shape,

  // undefined: 30_448 (99.87%), defined 40 (0.13%)
  commerce_data: whatsAppCommerceDataSchema,

  // Checkboxes
  generate_custom_attribute: z.boolean().optional().nullable(),
  should_use_mm_lite: z.boolean().optional(),

  // Carousel cards for carousel templates
  carousel_cards: z.array(whatsAppCarouselCardSchema).optional().nullable(),
});
